export class EquipmentSelection {
  equipSelected: any = null;
  validation: any = {
    equipValid: [],
  };
}
